import React from 'react';

import image_base from '../resources/image/GrandeeHamanako2.jpg';
import common from "../resources/js/common/common"
import { soloReservationList, getSoloVacancyOverview } from "../const";
import GolfSoloSearchTemplate from '../components/template/golfSoloSearchTemplate';

class GolfSoloSearch extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // 検索条件保存モーダル
            savedSearchCriteriaPopup: false,
            // カレンダーモーダル
            playDatePopup: false,
            // 開始時間モダール
            startTimePopup: false,
            // プランモーダル
            areaSelectionPopup: false,
            playDateFlg: false,
            popupDataList: [],
            golfReservationPopup: false,
            planCalendarPopup: false,
            courseId: "",
            planVacancyInfo: {
                planId: "",
                planName: "",
                vacancyDateList: []
            },
        };
    };

    render() {

        const style = {
            base: {
                backgroundImage: `url(${image_base})`,
                backgroundAttachment: "fixed",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                minHeight: "100%"
            },
        }
        // 予約確認モーダル
        const onClickOpenReservationPopupWindow = (loginId) => {
            this.setState({
                golfReservationPopup: true,
            });

            common.doPost(soloReservationList, { userId: loginId }, afterSoloReservationList);
        }

        // モーダルClose
        const onClickClosePopupWindow = () => { this.setState({ golfReservationPopup: false }); };

        // 予約情報取得後処理
        const afterSoloReservationList = (res) => {
            if (res.data.resultCode !== 0) {

            } else {
                this.setState(
                    {
                        popupDataList: res.data.reservationList,
                    }
                );
            }
        }

        // プランカレンダーモーダル
        const onClickOpenPlanCalendarWindow = (req, name, dispStartDate) => {
            this.setState(
                {
                    planCalendarPopup: true,
                    calendarStartDate: dispStartDate,
                    courseId: req.golfCourseId ? req.golfCourseId : "",
                    planCalendarFlg: true,
                    popupTitle: name ? name : ""
                }
            );
            // カレンダー検索用検索情報取得
            common.doPost(getSoloVacancyOverview, req, afterGetSoloVacancyOverview);
        }

        const afterGetSoloVacancyOverview = (res) => {
            const data = res.data;
            if (data.planList) {
                let planId = "";
                let planName = "";
                let vacancyList = [];
                data.planList.forEach((plan, index) => {
                    if (index === 0) {
                        planId = plan.planId;
                        planName = plan.planName;
                        plan.openTimeSlotDateList.map((vacancy) => {
                            let obj = {
                                openTimeSlotNum: vacancy.openTimeSlotNum,
                                riyoDate: vacancy.targetDate,
                                mark: vacancy.mark
                            }
                            vacancyList.push(obj);
                        });
                    }
                })
                this.setState({
                    planVacancyInfo: {
                        planId: planId,
                        planName: planName,
                        vacancyDateList: vacancyList
                    }
                });
            }
        }

        const onClickClosePlanCalendarWindow = () => { this.setState({ planCalendarPopup: false }); }

        const onClickCalendarMove = (req) => {
            // カレンダー検索用検索情報取得
            common.doPost(getSoloVacancyOverview, req, afterGetSoloVacancyOverview);
        }
        // カレンダーモーダル
        const onClickOpenSelectDateWindow = (e) => {
            this.setState({ playDatePopup: !this.state.playDatePopup });
            let flg = false;
            if (e != undefined) {
                if (e.target.id == 'playDate') {
                    flg = true;
                }
                else if (e.target.id == 'playDate1') {
                    flg = false;
                }
                this.setState({ playDateFlg: flg });
            }

        }
        // プランモーダル
        const onClickOpenSelectAreaWindow = () => this.setState({ areaSelectionPopup: !this.state.areaSelectionPopup });
        return (
            <div style={style.base}>
                <GolfSoloSearchTemplate
                    state={this.state}
                    onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}
                    onClickOpenSelectDateWindow={onClickOpenSelectDateWindow}
                    onClickOpenSelectAreaWindow={onClickOpenSelectAreaWindow}
                    onClickClosePopupWindow={onClickClosePopupWindow}
                    onClickCalendarMove={onClickCalendarMove}
                    onClickOpenPlanCalendarWindow={onClickOpenPlanCalendarWindow}
                    onClickClosePlanCalendarWindow={onClickClosePlanCalendarWindow} />
            </div>
        )
    }
}

export default GolfSoloSearch;